// Client-safe Pal index (~115 KB raw / ~16 KB gzipped) and breeding combos.
import indexJson from "~/app/pals-index.json";
import combosJson from "~/app/breeding-combos.json";
import { BreedingCalculator } from "~/app/utils/breeding";
import type { Combo, PalIndex } from "./pal-meta";

export * from "./pal-meta";

export const PAL_INDEX = indexJson as unknown as PalIndex[];
export const COMBOS = combosJson as unknown as Combo[];
export const MAX_WORK_LEVEL = Math.max(4, ...PAL_INDEX.flatMap((p) => p.suitability.map((s) => s.level)));

const byId = new Map(PAL_INDEX.map((p) => [p.id, p]));
export const palIndexById = (id: number) => byId.get(id);

let calcInstance: BreedingCalculator<PalIndex> | null = null;
/** Shared breeding calculator over the index + special combos (built on first use). */
export function breedingCalc(): BreedingCalculator<PalIndex> {
  return (calcInstance ??= new BreedingCalculator(PAL_INDEX, COMBOS));
}
